import { createSlice } from '@reduxjs/toolkit'

const productSlice = createSlice({
  name: 'product',
  initialState: [],
  reducers: {
    addProduct: (state, { payload }) => {
      state.push(payload)
      return state
    },
    removeProduct: (state, { payload }) => {
      state.splice(state.findIndex(item => item.id === payload.id), 1)
      return state
    },
    clearProduct: () => productSlice.initialState
  }
})

export const { addProduct, removeProduct, clearProduct } = productSlice.actions

export default productSlice.reducer